// noinspection JSFileReferences

import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import Point from 'ol/geom/Point.js';
import View from 'ol/View.js';
import {
	Circle as CircleStyle,
	Fill,
	Stroke,
	Style,
	Text,
} from 'ol/style.js';
import {transform} from "ol/proj";
import {Cluster, OSM, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {boundingExtent} from 'ol/extent.js';
import {defaults as defaultInteractions} from "ol/interaction";
import {Icon, RegularShape} from "ol/style";

let map;
let clusters;
let page = 0;
let parser = new DOMParser();

window.location.pathname === "/find-a-provider/search/" && (function() {
	if(!window.mapData) {
		window.mapData = [];
	}
	const count = mapData.length;
	const features = new Array(count);
	for (let i = 0; i < count; ++i) {
		const coordinates = [mapData[i]["lon"], mapData[i]["lat"]];
		features[i] = new Feature({
			geometry: new Point(transform(coordinates, "EPSG:4326", "EPSG:3857")),
			name: mapData[i].name,
		});
	}

	const source = new VectorSource({
		features: features,
	});

	const clusterSource = new Cluster({
		distance: 40,
		minDistance: 20,
		source: source,
	});

	const styleCache = {};
	clusters = new VectorLayer({
		source: clusterSource,
		style: function (cluster) {
			const size = cluster.get('features').length;
			let feature1 = cluster.get('features')[0];

			let style = size > 1 ? styleCache[size] : null;
			if (!style) {
				let shape;
				let text;
				if(size > 1) {
					shape = new CircleStyle({
						radius: 20,
						stroke: new Stroke({
							color: 'black',
							width: 2,
						}),
						fill: new Fill({
							color: '#3ba545',
						}),
					});
					text = new Text({
						text: size.toString(),
						font: "bold 1rem Ubuntu",
						fill: new Fill({
							color: '#fff',
						}),
					});
				}
				else {
					shape = new Icon({
						src: "/asset/icon/marker.svg",
						anchor: [0.5, 1],
					});
					text = new Text({
						text: feature1.get("name"),
						font: "0.8rem Ubuntu",
						fill: new Fill({
							color: 'black',
						}),
						backgroundFill: new Fill({
							color: "white"
						}),
						backgroundStroke: new Stroke({
							color: "black",
							width: 2,
						}),
						padding: [5, 5, 5, 5],
						offsetY: -30,
					});
				}

				style = new Style({
					image: shape,
					text: text,
				});

				if(size > 1) {
					styleCache[size] = style;
				}
			}
			return style;
		},
	});

	const raster = new TileLayer({
		source: new OSM(),
	});

	map = new Map({
		layers: [raster, clusters],
		interactions: defaultInteractions({mouseWheelZoom: false}),
		target: 'map',
		view: new View({
			center: [0, 0],
			zoom: 2,
			maxZoom: 21
		}),
	});

	map.on('click', (e) => {
		map.forEachFeatureAtPixel(e.pixel, function(feature) {
			const features = feature.get('features');
			if (features.length > 1) {
				const extent = boundingExtent(
					features.map((r) => r.getGeometry().getCoordinates())
				);
				map.getView().fit(extent, {duration: 1000, padding: [200, 200, 200, 200]});
			}
			else {
				let li = document.querySelector(`section.results>ul>li[data-name="${features[0].get("name")}"]`);
				if(li) {
					li.scrollIntoView({
						behavior: "smooth",
						block: "end",
					});

					li.classList.add("highlight");
					setTimeout(() => {
						li.classList.remove("highlight");
					}, 1000);
				}
				else {
					document.querySelector("global-footer").scrollIntoView({
						behavior: "smooth",
						block: "end",
					});
				}
			}
		});
	});

	map.on("moveend", toggleVisibilityOfVenueCards);

	const extent = source.getExtent();
	map.getView().fit(
		extent, {
			size: map.getSize(),
			padding: [200, 200, 200, 200],
			maxZoom: 10
		}
	);

	loadPage();
})();

function loadPage(loadAll = false) {
	let selector = "section.results>ul";
	let oldEl = document.querySelector(selector);
	oldEl.classList.add("loading");

	fetch(location.href, {
		headers: {
			"x-pagination": page,
		}
	}).then(response => {
		if(!response.ok) {
			console.log(response);
		}

		return response.text();
	}).then(html => {
		let newDocument = parser.parseFromString(html, "text/html");

		let newEl = newDocument.querySelector(selector);

		if(newEl.children.length === 0) {
			oldEl.classList.remove("loading");
			console.log("No more elements");
			return;
		}

		while(newEl.firstElementChild) {
			let newVenueEl = newEl.firstElementChild;
			newVenueEl.dataset.name;
			oldEl.appendChild(newVenueEl);
		}

		page++;
		console.log(`Page is ${page}`);

		if(loadAll) {
			loadPage(true);
		}
		else {
			setTimeout(() => { loadPage(true); }, 5000);
		}

		toggleVisibilityOfVenueCards()
	});
}

function toggleVisibilityOfVenueCards() {
	const extent = map.getView().calculateExtent(map.getSize());
	let features = clusters.getSource().getFeaturesInExtent(extent);
	let visibleFeatureNameList = [];

	features.forEach(function(feature) {
		// get the original features from cluster feature
		const originalFeatures = feature.get('features');
		originalFeatures.forEach(function(originalFeature) {
			visibleFeatureNameList.push(originalFeature.get('name'));
		});
	});

	document.querySelectorAll("section.results>ul>li").forEach(li => {
		li.classList.remove("hidden");
		if(!visibleFeatureNameList.includes(li.dataset.name)) {
			li.classList.add("hidden");
		}
	});
}
